const authInfoKey = 'qgv'

export function getLocalStorageItem(key) {
    try {
        return JSON.parse(b64DecodeUnicode(localStorage.getItem(key)))
    } catch (e) {
        return null
    }
}

export function setLocalStorageItem(key, value) {
    localStorage.setItem(key, b64EncodeUnicode(JSON.stringify(value)))
}

export function b64EncodeUnicode(str) {
    return btoa(
        encodeURIComponent(str).replace(
            /%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
                return String.fromCharCode('0x' + p1)
            }
        )
    )
}

export function b64DecodeUnicode(str) {
    try {
        return decodeURIComponent(
            atob(str)
                .split('')
                .map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
                })
                .join('')
        )
    } catch (e) {
        return null
    }
}

export const getAuthInfo = () => {
    return getLocalStorageItem(authInfoKey)
}

export const getPlaftormId = () => {
    var token = getAuthInfo()
    if (token) {
        if (
            !!token.access_token_expiration_ts &&
            token.access_token_expiration_ts > Date.now() &&
            !!token.platformId
        ) {
            try {
                return parseInt(token.platformId)
            } catch (e) {
                return 0
            }
        }
    }
    return 0
}

export const setAuthInfo = (value) => {
    setLocalStorageItem(authInfoKey, value)
}

export const removeTokenKey = () => {
    localStorage.removeItem(authInfoKey)
}

// ReCaptcha
const reCaptchaTokenKey = 'lhjkgfi319z'
export const setReCaptchaToken = (token) =>
    setLocalStorageItem(reCaptchaTokenKey, token)
export const getReCaptchaToken = () => getLocalStorageItem(reCaptchaTokenKey)
export const removeReCaptchaToken = () =>
    localStorage.removeItem(reCaptchaTokenKey)

// ShowOrderNewExplanation
const showOrderNewExplanationKey = '212aadjklioq982928'
export const setShowOrderNewExplanation = (enabled) =>
    setLocalStorageItem(showOrderNewExplanationKey, !enabled)
export const getShowOrderNewExplanation = () =>
    !getLocalStorageItem(showOrderNewExplanationKey)

const showDispatchToLockerExplanationVersionKey = 'eqrwi90u8reqopw9eer8p'
export const setShowDispatchToLockerExplanationVersion = (version) =>
    setLocalStorageItem(showDispatchToLockerExplanationVersionKey, version)
export const getShowDispatchToLockerExplanationVersion = () =>
    getLocalStorageItem(showDispatchToLockerExplanationVersionKey)

// ShowReverseLogisticsExplanation
const showReverseLogisticsExplanationKey = '312aakaklioq982928'
export const setShowReverseLogisticsExplanation = (enabled) =>
    setLocalStorageItem(showReverseLogisticsExplanationKey, !enabled)
export const getShowReverseLogisticsExplanation = () =>
    !getLocalStorageItem(showReverseLogisticsExplanationKey)

// ShowOrderNewExplanation
const showDispatchToLockerExplanationKey = '94jkd783m'
export const setShowDispatchToLockerExplanation = (enabled) =>
    setLocalStorageItem(showDispatchToLockerExplanationKey, !enabled)
export const getShowDispatchToLockerExplanation = () =>
    !getLocalStorageItem(showDispatchToLockerExplanationKey)
